const HexagonData = [
    {
        language:"JAVA",
        logo:"https://1000logos.net/wp-content/uploads/2020/09/Java-Emblem.jpg"
    },
    {
        language:"PYTHON",
        logo:"https://res.cloudinary.com/ddkdeeue3/image/upload/v1727152024/otwfl5c5pk7e7lhvexn0.jpg"
    },
    {
        language:"C++",
        logo:"https://logowik.com/content/uploads/images/911_c_logo.jpg"
    },
]

export default HexagonData